var _sodipodiNamedview, _defs, _metadata;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70mm",
    height: "70mm",
    viewBox: "0 0 70 70",
    id: "svg5",
    inkscapeVersion: "1.1.1 (3bf5ae0d25, 2021-09-20)",
    sodipodiDocname: "Close.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsCC: "http://creativecommons.org/ns#",
    xmlnsDC: "http://purl.org/dc/elements/1.1/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title1880"
  }, "Close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title1880"
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview7",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapePageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDocumentUnits: "mm",
    showgrid: "false",
    height: "50mm",
    inkscapeZoom: 2.8,
    inkscapeCX: 128.57143,
    inkscapeCY: 134.46429,
    inkscapeWindowWidth: 1920,
    inkscapeWindowHeight: 1005,
    inkscapeWindowX: -9,
    inkscapeWindowY: -9,
    inkscapeWindowMaximized: 1,
    inkscapeCurrentLayer: "layer1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Layer 1",
    inkscapeGroupmode: "layer",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7f7f7f",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "rect1113",
    width: 10,
    height: 10,
    x: 10,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7f7f7f",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "rect1113-0",
    width: 10,
    height: 10,
    x: 20,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7f7f7f",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "rect1113-2",
    width: 10,
    height: 10,
    x: 30,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7f7f7f",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "rect1113-8",
    width: 10,
    height: 10,
    x: 40,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7f7f7f",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "rect1113-1",
    width: 10,
    height: 10,
    x: 50,
    y: 50
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7f7f7f",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "rect1113-7",
    width: 10,
    height: 10,
    x: 40,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7f7f7f",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "rect1113-82",
    width: 10,
    height: 10,
    x: 50,
    y: 10.000001
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7f7f7f",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "rect1113-88",
    width: 10,
    height: 10,
    x: 20,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#7f7f7f",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "rect1113-89",
    width: 10,
    height: 10,
    x: 9.999999,
    y: 50
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata1878"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcTitle", null, "Close"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGray);
export default __webpack_public_path__ + "static/media/Close-gray.9f946fe9af1bf0d7606c8ab99bedbfa7.svg";
export { ForwardRef as ReactComponent };